import { render, staticRenderFns } from "./CustomerInfoCollect.vue?vue&type=template&id=1f11f4fa&scoped=true&"
import script from "./CustomerInfoCollect.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoCollect.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoCollect.vue?vue&type=style&index=0&id=1f11f4fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f11f4fa",
  null
  
)

export default component.exports